export const EXTERNAL_FILTER_ID = 'interest-vehicle-list-external-filter';
